import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default, { isValidElement, cloneElement } from 'react';
import { IconButton } from '../IconButton/IconButton.esm.js';
import styles from './ControlButton.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const ControlButton = React__default.forwardRef((_a, ref) => {
    var { className, inverse = false, icon } = _a, props = __rest(_a, ["className", "inverse", "icon"]);
    const classes = styles({
        inverse,
    });
    // Adding custom className to the icon
    const Icon = isValidElement(icon)
        ? cloneElement(icon, {
            className: cn(classes.icon(), icon.props.className),
        })
        : icon;
    return (jsx(IconButton, Object.assign({ ref: ref, className: cn(classes.box(), className), inverse: inverse, icon: Icon }, props)));
});
ControlButton.displayName = "ControlButton";

export { ControlButton };
